import { useCallback, useRef, useState, useEffect } from 'react';
import { Button, ModalBody, ModalFooter, Flex, Box } from '@chakra-ui/react';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import Input from '../../../Global/Input';
import { ModalComponent } from '..';
import Select from '../../../Global/SelectRelease';
import TextArea from '../../../Global/TextArea';
import { apllyToast } from '../../../Global/Toast2.0';
import { api } from '../../../../services/api';
import getValidationErrors from '../../../../utils/getValidationErrors';
import SelectUsers from './SelectUsers';

interface Props {
  isOpen: boolean;
  onClose: (isOpen: boolean) => void;
  setAddedNewData: (newData: any) => void;
  addedNewData: string;
}
interface strategicPropsFormated {
  value: string;
  label: string;
}
interface strategicProps {
  id: string;
  name: string;
}

interface Options {
  value: string;
  label: string;
}

export default function ModalAddNewIndicator({
  onClose,
  isOpen,
  setAddedNewData,
  addedNewData,
}: Props) {
  const formRef = useRef<FormHandles>(null);
  // const [dataPLacements, setDataPlacements] = useState<
  //   strategicPropsFormated[]
  // >([]);
  const [dataIndicator, setDataIndicator] = useState<strategicPropsFormated[]>(
    [],
  );
  const [dataSelectesUsers, setSelectedDataUsers] = useState<Options[]>([]);

  // useEffect(() => {
  //   try {
  //     api.get<strategicProps[]>('/strategic-placements').then(response => {
  //       if (response.data) {
  //         const placementsFormated = response.data.map(placement => {
  //           return {
  //             label: placement.name,
  //             value: placement.id,
  //           };
  //         });
  //         setDataPlacements(placementsFormated);
  //       }
  //     });
  //   } catch (e) {
  //     console.log('error', e);
  //   }
  // }, []);

  useEffect(() => {
    try {
      api.get<strategicProps[]>('/indicators').then(response => {
        if (response.data) {
          const indicatorsFormated = response.data.map(objectve => {
            return {
              label: objectve.name,
              value: objectve.id,
            };
          });
          setDataIndicator(indicatorsFormated);
        }
      });
    } catch (e) {
      console.log('error', e);
    }
  }, [addedNewData]);

  const handleSubmit = useCallback(
    async data => {
      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          name: Yup.string().required('Nome é obrigatório!'),
          unit: Yup.string().required('Unidade é obrigatória!'),
          indicator_id: Yup.string().required('Este campo é obrigatório!'),

          data_source_and_formula: Yup.string().required(
            'Este campo é obrigatório!',
          ),
          operational_definition: Yup.string().required(
            'Este campo é obrigatório!',
          ),
        });
        await schema.validate(data, {
          abortEarly: false,
        });

        await api.post('/sub-indicators', data).then(response => {
          const formatData = {
            sub_indicator_id: response.data.id,
            participant_ids: dataSelectesUsers.map(responsable => {
              return responsable.value;
            }),
          };
          console.log('formatData', formatData);
          api
            .post('/sub-indicators-of-participants/create-all', formatData)
            .then(res => {
              setAddedNewData(res.data);
              apllyToast(
                'success',
                'Sucesso ao adicionar novo Objetivo subindicador!',
              );
              onClose(!isOpen);
            });
        });
      } catch (err) {
        console.log(err);
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);

          formRef.current?.setErrors(errors);

          return;
        }

        apllyToast('error', 'Problemas ao adicionar novo subindicador!');
      }

      console.log(data);
    },
    [dataSelectesUsers, isOpen, onClose, setAddedNewData],
  );

  return (
    <>
      <ModalComponent
        isOpen={isOpen}
        onClose={() => onClose(!isOpen)}
        scrollBehavior="inside"
        // sizeSpecifyc="2xl"
        title="Adicionar novo Subindicador"
        sizeSpecifyc="2xl"
      >
        <ModalBody>
          <Form ref={formRef} onSubmit={handleSubmit}>
            <Flex flexDirection="column" mt="4">
              <Flex alignItems="center" justifyContent="space-between">
                <Flex flexDirection="column" w="100%" maxWidth={450}>
                  <p>Nome</p>
                  <Input name="name" />
                </Flex>
                <Box mb="6px">
                  <Select
                    name="unit"
                    label="Unidade de medida"
                    options={[{ label: 'label', value: 'value' }]}
                  />
                </Box>
              </Flex>

              {/* <Select
                name="classification"
                label="Classificação"
                options={[{ label: 'label', value: 'value' }]}
              /> */}

              <Select
                name="indicator_id"
                label="Indicador"
                options={dataIndicator}
              />

              <SelectUsers
                title="adicionar responsável"
                setSelectedDataUsers={setSelectedDataUsers}
                dataSelectesUsers={dataSelectesUsers}
              />

              {/* <Select
                label="Posicionamento estratégico"
                options={dataPLacements}
                name="strategic_placement_id"
              /> */}

              <p>Definição operacional</p>
              <TextArea name="operational_definition" />

              <p>Fontes de dados e fórmula</p>
              <TextArea name="data_source_and_formula" />

              <p>Observação</p>
              <TextArea name="observation" />
            </Flex>
            <ModalFooter>
              <Button variant="ghost" mr={3} onClick={() => onClose(!isOpen)}>
                Fechar
              </Button>
              <Button colorScheme="blue" type="submit">
                Salvar
              </Button>
            </ModalFooter>
          </Form>
        </ModalBody>
      </ModalComponent>
    </>
  );
}
